import * as React from 'react'

const Loading: React.SFC = () => (<div>Loading...</div>)

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading.tsx